// @flow

export const FETCH_MEDIA_SUCCESS = "FETCH_MEDIA_SUCCESS";
export const DELETE_MEDIA_ITEM = "DELETE_MEDIA_ITEM";
// export const LOAD_GALLERY_DATA = "LOAD_GALLERY_DATA";
export const SET_GALLERY_OPTIONS = "SET_GALLERY_OPTIONS";
export const SET_HAS_PASSWORD = "SET_HAS_PASSWORD";
export const SET_HAS_CODE = "SET_HAS_CODE";
export const SET_CAN_DOWNLOAD = "SET_CAN_DOWNLOAD";